import React from 'react';
import 'whatwg-fetch';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'mobx-react';
import stores from './stores';
import { BrowserRouter } from 'react-router-dom';
import { querystring as qs } from './utils/helpers';
import includes from 'array-includes';
import * as Sentry from '@sentry/react';
import { version } from '../package.json';

(async function init() {
    if (import.meta.env.REACT_APP_SENTRY_DSN) {
        try {
            await Sentry.close();
        } catch (e) {}
        Sentry.init({
            dsn: import.meta.env.REACT_APP_SENTRY_DSN,
            release: 'awarego-my@' + version,
            autoSessionTracking: false,
            integrations: [],
            tracesSampleRate: 0.0,
        });
    }
    includes.shim();

    window.__stores = stores;

    const container = document.getElementById('root');
    const root = createRoot(container);

    function main() {
        root.render(
            <Provider {...stores}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        );
    }

    const management_url = import.meta.env.REACT_APP_LMS_URL;

    //to window only for debug

    if (window.location.pathname === '/manager') {
        window.location.replace(management_url);
    } else if (window.location.pathname === '/auth/direct/signin') {
        let c = qs('c', window.location.search);
        let o = qs('o', window.location.search);
        let s = qs('s', window.location.search);
        let token = qs('at', window.location.search);
        window.location.replace(
            `${
                window.location.origin
            }/auth/direct/signin/${token}?${new URLSearchParams({
                c,
                o,
                s,
            }).toString()}`
        );
    } else if (window.location.pathname === '/') {
        let a = qs('a', window.location.search);
        let t = qs('t', window.location.search);
        if (a || t) {
            // TODO: need fix, a is not training id, its event id. need remap
            window.location.replace(
                `${window.location.origin}/training-event/${a || t}?`
            );
        } else {
            main();
        }
    } else {
        main();
    }
})();

